import React, { Component } from 'react'
import ViewContract from '../../../../../components/Purchasing/Supplier/Contract/ViewContract/ViewContract'
import { get, pick } from 'lodash'
import ContractsApi from '../../../../../api/Purchase/PurchaseContracts'
import Members from '../../../../../api/Members'
import { message } from 'antd'
import { execute } from '../../../../../modules/Utils'
import Suppliers from '../../../../../api/Purchase/Suppliers'
import moment from 'moment'
import DocumentsApi from '../../../../../api/Documents'

class ViewContractCont extends Component {
  uuid = moment().millisecond()

  constructor(props) {
    super(props)
    this.supplierKey = props.match.params.key
    this.contractKey = get(props.match, 'params.contractKey')
    this.state = {
      created: false,
      submitting: false,
      fetching: false,
      supplierFetching: false,
      updatingState: false,
      actions: [],
      member: {},
      supplier: {},
      contract: {},
      current: 0,
    }
    this.contractApi = new ContractsApi()
    this.supplierApi = new Suppliers()
    this.memberApi = new Members()
    this.docsApi = new DocumentsApi()
  }

  async componentDidMount() {
    await this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const supplierResponse = await this.supplierApi.get(this.supplierKey)
      let supplier = await supplierResponse.json()
      console.log({ supplier })
      const memberResponse = await this.memberApi.get((supplier.owner || '').replace('members/', ''))
      let member = await memberResponse.json()
      console.log({ member })

      const contract = await this.contractApi.get(this.contractKey)
      const actions = await this.docsApi.actions('purchaseContracts', contract.status)
      this.setState({
        member,
        supplier,
        contract,
        actions,
        fetching: false,
        supplierFetching: false,
      })
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({
        fetching: false,
        supplierFetching: false,
      })
    }
  }
  handleOps = async (operation, contract) => {
    const { approve, submit, revise, cancel, close, remove, reject } = this.contractApi
    const { supplier, member } = this.state
    const { history } = this.props
    switch (operation) {
      case 'revise':
        await execute(this, revise.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'update':
        history.push({
          pathname: `update`,
          state: { contract, supplier, member },
        })
        break
      case 'submit':
        await execute(this, submit.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'cancel':
        await execute(this, cancel.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'close':
        await execute(this, close.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'remove':
        try {
          await execute(this, remove.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
          history.replace({
            pathname: `/purchasing/suppliers/${member._key}`,
            hash: 'contracts',
          })
        } catch (e) {}
        break
      case 'approve':
        await execute(this, approve.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'terminate':
        this.onShowTermination()
        break
      case 'lines':
        this.setState({
          visibleLines: true,
          linesType: 'contract',
          contract,
        })
        break
      case 'reject':
        await execute(this, reject.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
    }
  }

  updateContractState = async (state) => {
    try {
      this.setState({
        updatingState: true,
      })
      const contract = await this.contractApi.updateState({
        ...pick(this.state.contract, ['_id', '_key', '_rev']),
        state,
      })
      this.setState({
        updatingState: false,
        contract,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        updatingState: false,
      })
    }
  }

  render() {
    return <ViewContract {...this.state} {...pick(this, ['handleOps', 'fetch', 'updateContractState'])} />
  }
}

ViewContractCont.propTypes = {}
ViewContractCont.defaultProps = {}

export default ViewContractCont
